var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2464",
    "data-name": "Group 2464",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.294,
    height: 23.702,
    viewBox: "0 0 31.294 23.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9949",
    "data-name": "Path 9949",
    d: "M199.738,110.464l-6.914-3.783a1.27,1.27,0,0,0-1.879,1.114v7.5a1.268,1.268,0,0,0,1.871,1.118l6.914-3.718a1.27,1.27,0,0,0,.008-2.233Zm-6.959,3.888v-5.606l5.167,2.827Zm0,0",
    transform: "translate(-179.275 -100.013)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9950",
    "data-name": "Path 9950",
    d: "M31.064,5.594V5.58a7.157,7.157,0,0,0-1.38-3.632A5.092,5.092,0,0,0,26.31.367L26.155.348,26.1.342C21.963.042,15.715,0,15.652,0h-.011c-.063,0-6.31.041-10.485.342L5.1.348,4.955.366A4.964,4.964,0,0,0,1.6,2,7.5,7.5,0,0,0,.234,5.562l0,.032C.221,5.7,0,8.194,0,10.7v2.342c0,2.5.221,5,.23,5.105l0,.016a7.087,7.087,0,0,0,1.374,3.587,5.2,5.2,0,0,0,3.486,1.559c.127.015.237.027.312.04l.072.01c2.389.227,9.878.339,10.2.344h.019c.063,0,6.31-.041,10.447-.342l.055-.006c.052-.007.111-.013.175-.02a4.849,4.849,0,0,0,3.324-1.59,7.5,7.5,0,0,0,1.368-3.566l0-.032c.009-.105.23-2.6.23-5.105V10.7C31.294,8.194,31.073,5.7,31.064,5.594Zm-1.6,7.447c0,2.319-.2,4.706-.222,4.925a5.822,5.822,0,0,1-.9,2.54,3.016,3.016,0,0,1-2.164,1l-.2.022c-4,.289-10.014.334-10.29.335-.311,0-7.69-.117-10.006-.333-.119-.019-.247-.034-.382-.049a3.429,3.429,0,0,1-2.345-.98l-.017-.018a5.282,5.282,0,0,1-.882-2.515c-.015-.166-.222-2.582-.222-4.933V10.7c0-2.316.2-4.7.222-4.925a5.7,5.7,0,0,1,.9-2.541,3.164,3.164,0,0,1,2.21-1.046l.149-.018c4.06-.291,10.115-.334,10.332-.336s6.27.045,10.294.336l.161.019a3.284,3.284,0,0,1,2.246,1.017l.007.008a5.368,5.368,0,0,1,.882,2.552c.014.156.222,2.578.222,4.934Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.528fa47c105043fe0e83550334510eca.svg";
export { ForwardRef as ReactComponent };